import GLU from '../glu2.js/src/index';

class NewReportApi extends GLU.Api {
    constructor(endpoint) {
        super(endpoint);

        this.createApiActions(
            {
                name: 'getReportLimits',
                method: GLU.Api.Get,
                path: '/limits',
                credentials: true,
            },
        );
    }
}

export default NewReportApi;
